module.exports = __webpack_public_path__ + "img/categorie-epicerie-famille-boutrais-small.1f9385a5.jpg";